<template>
    <v-container>
        <h1 class="titulo mb-3">RESTRIÇÕES DE VENDA</h1>
        <div>
            <div id="tabs" class="container">
                <div class="tabs">
                    <a @click="activetab = SALE_RESTRICTIONS" :class="{ active: activetab === SALE_RESTRICTIONS }">
                        Restrições de Venda
                    </a>
                    <a @click="activetab = LOCAL_GROUPS" :class="{ active: activetab === LOCAL_GROUPS }">
                        Grupos Exclusivos
                    </a>
                    <a @click="activetab = VALID_CORRECTION_INDEXES" :class="{ active: activetab === VALID_CORRECTION_INDEXES }">
                        Índices de Correção Válidos
                    </a>
                    <a @click="activetab = BLOCKING_PEAPLE" :class="{ active: activetab === BLOCKING_PEAPLE }">
                        Bloqueio de Pessoas
                    </a>
                </div>

                <div class="content">
                    <div v-if="activetab === SALE_RESTRICTIONS" class="tabcontent">
                        <GruposVendas />
                    </div>
                    <div v-if="activetab === LOCAL_GROUPS" class="tabcontent">
                        <GruposLocais />
                    </div>
                    <div v-if="activetab === VALID_CORRECTION_INDEXES" class="tabcontent">
                        <IndicesCorrecaoValidos />
                    </div>
                    <div v-if="activetab === BLOCKING_PEAPLE" class="tabcontent">
                        <BloqueioPessoas />
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
  import GruposVendas from './GruposVendas.vue'
  import GruposLocais from './GruposLocais.vue'
  import IndicesCorrecaoValidos from './IndicesCorrecaoValidos.vue'
  import BloqueioPessoas from './BloqueioPessoas.vue'

  export default {
    name: 'RestricoesVendaAba',
    components: {
      GruposVendas,
      GruposLocais,
      IndicesCorrecaoValidos,
      BloqueioPessoas
    },
    data: () => ({
      activetab: 'sale_restrictions'
    }),
    computed: {
      SALE_RESTRICTIONS: () => 'sale_restrictions',
      LOCAL_GROUPS: () => 'local_groups',
      VALID_CORRECTION_INDEXES: () => 'valid_correction_indexes'
    }
  }
</script>

<style scoped lang="scss">

@import url('../../../assets/css/tabs.css');
</style>
